module.exports = __webpack_public_path__ + "static/img/photo-03.ad40754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-03.jpg
// module id = IHsF
// module chunks = 1